const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1088d9d355c3de1a503147c64d59b733.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_2 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/4c44f4708b4c12c13b16bd045e0dcfa4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    